import { useCallback } from 'react'
import { DEFAULT_SETTINGS_SECTION_ID } from '@/data/settingsNavData'
import { PRIMARY_ACCOUNT_MENU_ACTION } from '@/components/AccountMenu/primaryNavAccountMenuConfig'
import { useSettingsModal } from '@/components/Settings/SettingsModal/SettingsModalContext'
import { useAppearanceTheme } from '@/theme/AppThemeProvider'

/** @param {{ navigate: Function }} m */
export function useAccountMenuAction() {
  const { openSettings } = useSettingsModal()
  const { resolvedMode, setMode } = useAppearanceTheme()
  const handleAccountMenuAction = useCallback(
    (id) => {
      if (id === PRIMARY_ACCOUNT_MENU_ACTION.THEME) {
        setMode(resolvedMode === 'dark' ? 'light' : 'dark')
        return
      }
      if (id === PRIMARY_ACCOUNT_MENU_ACTION.SETTINGS) {
        openSettings(DEFAULT_SETTINGS_SECTION_ID)
      }
    },
    [openSettings, resolvedMode, setMode],
  )
  return { handleAccountMenuAction }
}
